module.exports = __webpack_public_path__ + "img/pingpongWhite.52990966.svg";